import { create } from "zustand";
import { checkAuth } from "../src/services/apiServices";

interface AuthState {
  isAuthenticated: boolean | null;
  verifyAuth: () => Promise<void>;
  setIsAuthenticated: (auth: boolean) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  isAuthenticated: null, // Initially unknown
  verifyAuth: async () => {
    try {
      await checkAuth();
      set({ isAuthenticated: true });
    } catch {
      set({ isAuthenticated: false });
    }
  },

  setIsAuthenticated: (auth: boolean) => set({ isAuthenticated: auth }),
}));
